import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  openDialog: false,
  openPopupDialog: false,
  message: '',
  currentPasswordVisible: false,
  newPasswordVisible: false,
  confirmPasswordVisible: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setOpenDialog: (state, action) => {
      state.openDialog = action.payload;
    },
    setOpenPopupDialog: (state, action) => {
      state.openPopupDialog = action.payload;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    toggleCurrentPasswordVisibility: (state) => {
      state.currentPasswordVisible = !state.currentPasswordVisible;
    },
    toggleNewPasswordVisibility: (state) => {
      state.newPasswordVisible = !state.newPasswordVisible;
    },
    toggleConfirmPasswordVisibility: (state) => {
      state.confirmPasswordVisible = !state.confirmPasswordVisible;
    },
    clearMessage: (state) => {
      state.message = '';
    },
  },
});

export const {
  setOpenDialog,
  setOpenPopupDialog,
  setMessage,
  toggleCurrentPasswordVisibility,
  toggleNewPasswordVisibility,
  toggleConfirmPasswordVisibility,
  clearMessage,
} = uiSlice.actions;

export default uiSlice.reducer;